export default function AbyanLogoSmall() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.96945 20.6979C7.49681 20.2967 15.155 14.7134 17.8769 16.9017C18.6422 17.5183 18.9418 18.7551 18.5674 19.6501C17.6863 21.7622 12.8485 22.6837 6.96945 20.7011V20.6979ZM21.3028 12.5419C18.7443 10.3007 15.1619 10.9835 14.097 11.1924C8.11607 12.3629 5.70732 18.2014 4.99956 18.7948C3.45848 14.8095 4.51984 11.5605 7.30962 9.23308C10.5961 6.49123 15.8627 6.65354 19.2649 9.89616C20.4183 7.73781 21.5683 5.57945 22.7214 3.42109C16.8937 -0.743072 9.64357 -1.08451 4.9963 2.28055C4.3974 2.71488 -0.175075 6.11982 0.00518896 11.8125C0.155055 16.527 3.45169 19.4646 4.08099 20.0049C3.38368 21.0096 2.68624 22.0141 1.9854 23.0187C2.31525 23.347 2.64877 23.6751 2.97876 24C4.05384 23.0884 5.13231 22.1732 6.20739 21.2615C13.9098 24.9217 20.8605 23.8972 22.8235 20.5952C24.1061 18.44 23.6774 14.6206 21.3028 12.5386V12.5419Z"
        fill="#155DFC"
      />
    </svg>
  );
}
